import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./Sidebar.css";

function Sidebar({ links, basePath, badges }) {
  const location = useLocation();

  const isActive = (path) => {
    return (
      location.pathname === `${basePath}${path}` ||
      location.pathname.startsWith(`${basePath}${path}/`)
    );
  };

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <Link to="/" className="sidebar-logo">
          <div className="logo-icon-small">DSTL</div>
          <span>Data Space Tech</span>
        </Link>
      </div>

      <nav className="sidebar-nav">
        {links.map((link) => {
          const badgeCount = badges?.[link.path] || 0;
          return (
            <Link
              key={link.path}
              to={`${basePath}${link.path}`}
              className={`sidebar-link ${isActive(link.path) ? "active" : ""}`}
            >
              <span className="sidebar-icon">
                {typeof link.icon === "string" ? (
                  link.icon
                ) : (
                  <link.icon className="sidebar-icon-svg" />
                )}
              </span>
              <span className="sidebar-label">{link.label}</span>
              {badgeCount > 0 && (
                <span className="sidebar-badge">{badgeCount > 99 ? "99+" : badgeCount}</span>
              )}
            </Link>
          );
        })}
      </nav>
    </div>
  );
}

export default Sidebar;
